import canvasConfetti from "canvas-confetti";

const colors = [
    "#FF4C4C",
    "#FFB800",
    "#4CDBFF",
    "#9B4CFF"
];
export function confetti() {
    canvasConfetti({
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
        zIndex: 9999
    });
    canvasConfetti({
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
        zIndex: 9999
    });
}